var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TqHeader_1;
import { JSON, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { tqHeaderSchemaValidation } from '../validations.generated';
export var TqColumnType;
(function (TqColumnType) {
    TqColumnType["TEXT"] = "text";
    TqColumnType["CHARACTER_VARYING"] = "character varying";
    TqColumnType["INTEGER"] = "integer";
    TqColumnType["NUMERIC"] = "numeric";
    TqColumnType["DATE"] = "date";
})(TqColumnType || (TqColumnType = {}));
export const tqHeaderSchema = {
    $id: 'urn:wisepipe-common-export:TqHeader',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1 },
        required: { type: 'boolean' },
        type: { type: 'string', enum: Object.values(TqColumnType) }
    },
    required: ['name', 'required', 'type']
};
// Class that represents a tq-input's required+nonrequired csv/table header definition
let TqHeader = TqHeader_1 = class TqHeader {
    constructor(name, required, type) {
        this.name = name;
        this.required = required;
        this.type = type;
        JSON.validate(this, TqHeader_1);
    }
};
TqHeader = TqHeader_1 = __decorate([
    JsonSchemaV2(tqHeaderSchema, tqHeaderSchemaValidation)
], TqHeader);
export { TqHeader };
//# sourceMappingURL=tqHeader.js.map